// Vue 3: Use createRouter and createWebHistory
import { createRouter, createWebHistory } from "vue-router"

import store from "@/store/index"
import atmdoc from "./atmroutes/document"
import atminfo from "./atmroutes/info"
import atmreport from "./atmroutes/report"
import golddocument from "./gold/document"
import goldinfo from "./gold/info"
import goldreport from "./gold/report"
import document from "./routes/document"
import info from "./routes/info"
import managment from "./routes/managment"
import others from "./routes/others"
import pages from "./routes/pages"
import report from "./routes/report"

const Dashboard = () => import("@/views/dashboard")

// Vue 3: Use createRouter instead of new VueRouter
const router = createRouter({
  // Vue 3: Use createWebHistory instead of mode: 'history'
  history: createWebHistory(import.meta.env.BASE_URL || "/"),
  // Vue 3: scrollBehavior uses left/top instead of x/y
  scrollBehavior() {
    return { left: 0, top: 0 }
  },
  routes: [
    ...info,
    ...managment,
    ...document,
    ...report,
    ...atminfo,
    ...atmdoc,
    ...atmreport,
    ...goldinfo,
    ...golddocument,
    ...goldreport,
    { path: "/dashboard", name: "maindashboard", component: Dashboard },
    { path: "/", redirect: { name: "maindashboard" } },
    ...pages,
    ...others,
    {
      // Vue 3: Catch-all route syntax
      path: "/:pathMatch(.*)*",
      redirect: "/error-404",
    },
  ],
})

const isTabbableRoute = item => item?.meta?.layout !== "full"

function isExcludedTabName(name) {
  return typeof name === "string"
    && (name.startsWith("auth-") || name.startsWith("error-"))
}

function fiveRoutes(item) {
  if (!isTabbableRoute(item))
    return

  let routes = []
  const stored = JSON.parse(localStorage.getItem("enteredRoutes"))
  const data = Array.isArray(stored)
    ? stored.filter(el => !isExcludedTabName(el.name))
    : stored
  // Vue 3: Safely access meta.pageTitle (meta might be undefined for redirect routes)
  const pageTitle = item.meta?.pageTitle || item.name
  if (!data || data.length === 0) {
    routes.push({
      path: item.path,
      query: item.query,
      params: item.params,
      name: item.name,
      title: pageTitle,
    })
    localStorage.setItem("enteredRoutes", JSON.stringify(routes))
    localStorage.setItem("enteredRouteIndex", 0)
    store.commit("app/SET_ENTERED_ROUTES", routes)
    store.commit("app/SET_ENTERED_ROUTE_INDEX", 0)
  } else {
    routes = data
    const isRouteIn = routes.find(el => el.name == item.name)
    if (!isRouteIn) {
      if (data.length === 5) {
        routes.shift()
        routes.push({
          path: item.path,
          query: item.query,
          params: item.params,
          name: item.name,
          title: pageTitle,
        })
        localStorage.setItem("enteredRoutes", JSON.stringify(routes))
        store.commit("app/SET_ENTERED_ROUTES", routes)
        localStorage.setItem("enteredRouteIndex", routes.length - 1)
        store.commit("app/SET_ENTERED_ROUTE_INDEX", routes.length - 1)
      } else {
        routes.push({
          path: item.path,
          query: item.query,
          params: item.params,
          name: item.name,
          title: pageTitle,
        })
        localStorage.setItem("enteredRoutes", JSON.stringify(routes))
        store.commit("app/SET_ENTERED_ROUTES", routes)
        localStorage.setItem("enteredRouteIndex", routes.length - 1)
        store.commit("app/SET_ENTERED_ROUTE_INDEX", routes.length - 1)
      }
    } else {
      const index = routes.findIndex(i => i.name === item.name)
      routes[index].query = item.query
      localStorage.setItem("enteredRoutes", JSON.stringify(routes))
      localStorage.setItem("enteredRouteIndex", index)
      store.commit("app/SET_ENTERED_ROUTE_INDEX", index)
    }
  }
}

router.beforeEach((to, from, next) => {
  const isAuth = !!localStorage.getItem("user_info")

  if (to.path !== "/login") {
    if (isAuth) {
      fiveRoutes(to)
      next()
    } else {
      next("/login")
    }
  } else {
    fiveRoutes(to)
    next()
  }
})

export default router
